import { imgUrlChk } from '@/utils/function';
import Image from 'next/image';
import React, { useState } from 'react';

type P = {
  url: string;
  size?: number;
  id: string;
  /**
   * 검색 드롭다운처럼 다건 아바타가 입력마다 재렌더되는 곳에서 Next 이미지 최적화
   * (/_next/image 리사이즈 round-trip)를 건너뛰어 첫 표시를 앞당긴다. 기본 false(기존 동작 유지).
   */
  unoptimized?: boolean;
};
const ProfileImage = ({ url, size = 20, id, unoptimized = false }: P) => {
  const [profileImgError, setProfileImgError] = useState(false);
  return (
    <Image
      style={{
        borderRadius: '50%',
        objectFit: 'cover',
        height: size,
      }}
      width={size}
      height={size}
      unoptimized={unoptimized}
      loading="lazy"
      src={
        profileImgError
          ? '/images/profile/errorProfileImage.svg'
          : imgUrlChk(url)
      }
      alt={`${id}-profile`}
      onError={() => setProfileImgError(true)}
    />
  );
};
export default ProfileImage;
